<template>
  <div class="rich-editor">
    <div class="rich-toolbar">
      <el-button size="mini" @click="format('bold')">加粗</el-button>
      <el-button size="mini" @click="format('insertUnorderedList')">列表</el-button>
      <el-button size="mini" @click="formatBlock('h3')">小标题</el-button>
      <el-button size="mini" @click="formatBlock('p')">正文</el-button>
    </div>
    <div
      ref="editor"
      class="rich-area"
      contenteditable="true"
      @input="emitChange"
      @blur="emitChange"
    ></div>
  </div>
</template>

<script>
export default {
  name: "RichTextEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.syncHtml();
  },
  watch: {
    value() {
      this.syncHtml();
    }
  },
  methods: {
    syncHtml() {
      const editor = this.$refs.editor;
      if (editor && editor.innerHTML !== (this.value || "")) {
        editor.innerHTML = this.value || "";
      }
    },
    emitChange() {
      this.$emit("input", this.$refs.editor ? this.$refs.editor.innerHTML : "");
    },
    format(command) {
      document.execCommand(command, false, null);
      this.emitChange();
    },
    formatBlock(tag) {
      document.execCommand("formatBlock", false, tag);
      this.emitChange();
    }
  }
};
</script>

<style scoped>
.rich-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.rich-toolbar {
  display: flex;
  gap: 6px;
  padding: 8px;
  background: #f7f8fa;
  border-bottom: 1px solid #ebeef5;
}

.rich-area {
  min-height: 180px;
  padding: 12px;
  line-height: 1.7;
  outline: none;
}
</style>
